import { Component, ViewEncapsulation, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'lib-sub-footer',
    templateUrl: './sub-footer.component.html',
    styleUrls: ['./sub-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
export class SubFooterComponent {
  readonly message = input(`If you have a disability and are having trouble accessing information on this website or need materials in an alternate format, contact <a href="mailto:naturerx@cornell.edu">naturerx@cornell.edu</a> for assistance.`);
}
